import React,{useCallback,useReducer,useRef,useImperativeHandle} from 'react';
import {FaCheckDouble,FaPrint,FaQrcode,FaUnlock,FaCamera,FaQuestion, FaLock,FaBroom} from 'react-icons/fa';
import {Dropdown,Container,ButtonGroup} from 'react-bootstrap'
import {initialState,reducer,QrTableCSV} from "./components";
import {MatchesTable,PrintTable,RecordTable,UnlockTable,MatchTable,UnclearTable, ClearTable} from './type';
import {RSearchField} from '@putil-view/input.r-search-field';
import {RAjax} from '@putil-view/request.r-ajax';
import {useQuery} from '@putil-view/use.use-query';
import {SysPath} from 'SysContext';
import PropTypes from 'prop-types';
import 'css/qr-match.css';
import "react-datepicker/dist/react-datepicker.css";

const QrTable =  React.forwardRef((props, ref) => {
	const [state, dispatch] = useReducer(reducer, initialState); //state will be controlled by reducer when dispatch is executed. initialState is used as default value of state.
	const queryRef = useRef(useQuery());
	const keyword = state.keyword;
	const sort = state.sort;
	const dataType = props.dataType? props.dataType : state.dataType; //If parent provide dataType, searching function will be disabled.
	const stage = state.stage;
	const limit = parseInt(state.limit);
	const paginationNum = parseInt((state.offset)/limit + 1);
	const count = state.count;
	const rows = state.rows;
	const requestCount = state.requestCount;
	const offset =state.offset;
	const searchRef = useRef();

	//Provide interface to allow parent execute child's function. Qr page as parent can use ref to execute QrTable functions.
	useImperativeHandle(ref, () => ({
		reset(){
			dispatch({type:"reset"});
		}
	}));

	const handleSort = useCallback((e) =>{
		const field = e.currentTarget.getAttribute('name');
		dispatch({type:"handleSort", field:field})
	},[dispatch])

	const handleSearch = useCallback((event) =>{
		const keyword = event.target.value;
		clearURLParams();
		dispatch({type:"handleSearch", keyword:keyword})
	},[dispatch])

	const handlePaginationNum = useCallback((paginationNum) =>{
		const offset= paginationNum === 1 ? 0 : limit * (paginationNum - 1);
		dispatch({type:"handlePaginationNum",offset:offset})

	},[limit,dispatch])

	//delete url param and replace browser url.
	const clearURLParams =()=>{
		queryRef.current.clearParams({
			data: 'data',
			id: 'id',
			type: 'type'
		})
		queryRef.current.updateBrowserQuery();
	}

	const drawMatchSquare = ()=>{
		var className ="";
		//Only draw match square for first page of table, latest data sorting, no keyword. If not, add "match-square-none" class to remove match square.
		if(((offset !== "0" && offset !== 0)||!sort['Create Time']||keyword||(sort['Create Time'].indexOf('descending') === -1))){
			className = "match-square-none";
		}
		return className;
	}

	const DataTypeToggle = ({dataType}) =>{
		const handleDataTypeToggle = (type) =>{
			searchRef.current.clearKeyword();
			clearURLParams();
			dispatch({type:type});
		};
		return(
			<Dropdown>
				<Dropdown.Toggle className="btn-success bg-custom-green" id="dropdown-basic">
					{(()=>{
						const buttonDisplay ={
							"labels":<><FaQrcode className="h5 mb-0"/><small className="pl-2">QR Record</small></>,
							"prints": <><FaPrint className="h5 mb-0"/><small className="pl-2">Print Record</small></>,
							"scans": <><FaCamera className="h5 mb-0"/><small className="pl-2">Scan Record</small></>,
							"clear": <><FaBroom className="h5 mb-0"/><small className="pl-2">Clear Record</small></>,
							"unclear": <><FaLock className="h5 mb-0"/><small className="pl-2">Unclear Record</small></>,
							"unlocks": <><FaUnlock className="h5 mb-0"/><small className="pl-2">Unlock Record</small></>,
							"matches": <><FaCheckDouble className="h5 mb-0"/><small className="pl-2">Match Record</small></>,
							"mismatch": <><FaQuestion className="h5 mb-0"/><small className="pl-2">Mismatch Record</small></>
						}
						return buttonDisplay[dataType];
					})()}
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("labels")}>
						<><FaQrcode className="h5 mb-0"/><small className="pl-2">QR Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("prints")}>
						 <><FaPrint className="h5 mb-0"/><small className="pl-2">Print Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("clear")}>
						<><FaBroom className="h5 mb-0"/><small className="pl-2">Clear Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("unclear")}>
						<><FaLock className="h5 mb-0"/><small className="pl-2">Unclear Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("matches")}>
						<><FaCheckDouble className="h5 mb-0"/><small className="pl-2">Match Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("unlocks")}>
						<><FaUnlock className="h5 mb-0"/><small className="pl-2">Unlock Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("scans")}>
						<><FaCamera className="h5 mb-0"/><small className="pl-2">Scan Record</small></>
					</Dropdown.Item>
					<Dropdown.Item onClick={()=>handleDataTypeToggle("mismatch")}>
						<><FaQuestion className="h5 mb-0"/><small className="pl-2">Mismatch Record</small></>
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		)
	}


	return(
			<>
				<ButtonGroup bsPrefix="d-flex">
				{!props.isFixedDataType && //Hide the Table Select button if isFixedDataType is specficed as true in parent
						<DataTypeToggle dataType={dataType}/>
				}
				<RSearchField
					placeHolder={props.target === "self"? " Search my record" : " Search"}
					ref={searchRef}
					keyword={keyword}
					handleSearch={handleSearch}

				/>
				{!props.isFixedDataType && //Hide the Table Select button if isFixedDataType is specficed as true in parent
						<QrTableCSV keyword={keyword} dataType={dataType}/>
				}
				</ButtonGroup>

				{stage === "REQUEST_RECORDS" &&
					(()=>{
						let url = "";
						let params = queryRef.current.getParams(
							{
								dataType:null,
								id:null,
								type:null
							}
						)
						if(keyword === ''  && params.id &&  params.type && params.dataType){ //If keyword is not defined and URLSearchParams are provided
							params.keyword = params.id + " " + params.dataType; //Put URLSearchParams to keyword
							params.sort = {}; //No sorting. The most relevence will be top of table.
						}
						else {
							params.keyword = keyword
							params.dataType = dataType;
							params.sort = sort;
						}
						const urls ={
								"match": SysPath.getByKeywordUrl,
								"unclear": SysPath.getUnclearRecordsByKeywordUrl,
								"clear": SysPath.getClearRecordsByKeywordUrl,
								"matches": SysPath.getMatchRecordsByKeywordUrl,
								"labels": SysPath.getLabelUrl,
								"prints": SysPath.getPrintRecordsByKeywordUrl,
								"scans": SysPath.getByKeywordUrl,
								"unlocks": SysPath.getUnlockRecordsUrl,
								"mismatch": SysPath.getMismatchRecordsUrl
						}
						url = urls[params.dataType] + "?keyword="+params.keyword+"&limit="+limit+"&offset="+offset + (requestCount === "" ? "" : "&count="+requestCount) + "&sort=" + encodeURI(JSON.stringify(params.sort)) + (props.target?"&target="+props.target : "");
						return(
							<RAjax requestResponse={true}
									requestOptions={{
										method: 'get',
										withCredentials: true,
										url: url
									}}
								handleResponse={(response)=>{
									if(response &&response.data &&response.data.datas)
										dispatch({type:"updateRecords", datas: response.data.datas,count:response.data.count,dataType:params.dataType})
								}}
							/>
						)

					})()

				}

			<Container bsPrefix={stage !== "DISPLAY_RECORDS"? "overflow-hidden": "fade-in overflow-auto"} className={drawMatchSquare}>
				{(()=>{
					const isLoading = stage !== "DISPLAY_RECORDS"? true: false;
					const config = {
						spinner: isLoading,
						limit: limit,
						paginationNum:paginationNum
					}
					const datas = {
						rows: rows,
						count: count,
					}
					const table = {
						"match": <MatchTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"clear": <ClearTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"unclear": <UnclearTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"matches": <MatchesTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"labels": <PrintTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"prints": <RecordTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"scans": <RecordTable config={config} datas={datas}handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"unlocks" :<UnlockTable config={config} datas={datas} handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
						"mismatch": <RecordTable config={config} datas={datas}handleSort={handleSort} handlePaginationNum={handlePaginationNum}/>,
					}
					return table[dataType];
				})()}

				</Container>
		</>
	);
})

QrTable.propTypes = {
	dataType: PropTypes.string,
	target :PropTypes.string,
	isFixedDataType :PropTypes.bool,
};
QrTable.displayName = "QrTable";
export default QrTable;
